// 引入vuex
import { mapState, mapMutations } from "vuex";
import {
  loginSystem,
  getListEngineer,
  getLikePath,
  getOrganizationList,
  exportToUserList,
  addUserViewApi,
  addOrganizationUsersApi,
  delOrganizationUsersApi,
  dataAuthorizationViewApi,
  dataAuthorizationAllEngViewApi,
  dataAuthorizationUserViewApi,
  addOrganizationRoleApi,
  clearOrganizationRoleApi
} from '@/api/api'
const columns = [
  {
    title: '序号',
    dataIndex: 'id',
    key: 'id',
    width: 80,
    align:'center'
  },
  {
    title: '用户名',
    dataIndex: 'loginName',
    key: 'loginName',
    width: 100,
    align:'center'
  },
  {
    title: '姓名',
    key: 'name',
    dataIndex: 'name',
    width: 100,
    align:'center'
  },
  {
    title: '职务',
    key: 'duty',
    dataIndex: 'duty',
    width: 150,
    align:'center'
  },
  {
    title: '归属单位',
    key: 'companyName',
    dataIndex: 'companyName',
    width: 220,
    align:'center'
  },
  {
    title: '手机号码',
    key: 'mobile',
    dataIndex: 'mobile',
    width: 150,
    align:'center'
  },
  {
    title: '邮箱',
    key: 'email',
    dataIndex: 'email',
    align:'center'
  },
  {
    title: '权限',
    key: 'roles',
    dataIndex: 'roles',
    align:'center',
    scopedSlots: { customRender: 'roles' },
  },
];

const data = [];
const plainOptions = [];
const defaultCheckedList = [];
export default {
  data() {
    return {
      engId:'',
      nodeId:"",
      checkedList: defaultCheckedList,
      indeterminate: false,
      checkAll: false,
      plainOptions,
      zzType:'',
      zzName:'',
      userId:'',
      zzPid: '',
      companyId:'',
      userOrgList:[],
      userList:[],
      delOrgIds:[],
      userIds:[],
      orgNames:[],
      // 数据授权弹窗（所有工程树形）
      authTreeData: [],
      authExpandedKeys: [],
      authCheckedKeys: [],
      authSearchVal: '',
      orgEngMap: {},
      checkAllData: false,
      indeterminateData: false,
      // 是否选择其他项目开关：关闭=当前工程复选框列表（原样式），开启=所有工程树
      authShowAllEng: false,
      // 开关关闭态：当前工程组织复选框
      authOrgOptions: [],
      authCheckedList: [],
      authCheckAll: false,
      authIndeterminate: false,
      // 编辑权限模式：回显已有授权
      editingAuth: false,
      editingUserRoles: [],
      val: 'Hello moto',
      labelAlign:'right',
      loading: false,
      visible: false,
      loadingData: false,
      visibleData: false,
      searchVal: {
        userName: '',
        name: '',
        role: '',
        tel: ''
      },
      data,
      orgPath:'',
      columns,
      // 分页
      pagination: {
        current: 1,
        total: 1,
        pageSize: 10, //每页中显示10条数据
        showSizeChanger: true,
        showQuickJumper: true,
        // position:['bottomLeft'],
        pageSizeOptions: ['10', '20', '50', '100'], //每页中显示的数据
        // showTotal: total => `共有 ${total} 条数据` //分页中显示总的数据
        showTotal: (total, range) => `显示${range[0]}-${range[1]}条，共有 ${total}条` //分页中显示总的数据
      },
    }
  },
  created() {

  },
  mounted() {
    console.log(this.val)
  },
  methods: {
    // 引入store方法
    ...mapMutations(['updateCount']),
    // 获取子组件值
    childVal(e) {
      console.log(e)
      this.nodeId = e.id
      this.zzType = e.type
      this.zzName = e.name
      this.orgPath = e.path
      this.zzPid = e.pid
    },
    engVal(e){
      this.engId = e;
      console.log(e)
    },
    onChangeData(checkedList) {
      console.log(checkedList)
      this.orgNames = checkedList;
      this.indeterminate = !!checkedList.length && checkedList.length < this.plainOptions.length;
      this.checkAll = checkedList.length === this.plainOptions.length;
    },
    onCheckAllChange(e) {
      console.log(e.target.checked)

      if(e.target.checked) {
        this.plainOptions.forEach(item=> {
          this.orgNames.push(item.value)
        })
      }else {
        this.orgNames = []
      }

      Object.assign(this, {
        checkedList: e.target.checked ? this.orgNames : [],
        indeterminate: false,
        checkAll: e.target.checked,
      });
    },
    showModal() {
      let path = this.orgPath;
      if(path.split("/").length >= 5){
        this.visible = true;
      }

      console.log('--++++'+this.zzType+'--'+this.zzName)
      let params = {
          //companyId : this.companyId,
          id:this.nodeId,
          type: this.zzType,
          pid: this.zzPid, 
          engineeringId: this.engId,
      }
      addUserViewApi(params).then(res => {
        if(res.data.code == 200){
          this.userOrgList = res.data.data
        }
        console.log(res)
      })
    },
    handleOk() {
      
      console.log('--------'+this.zzType+'--'+this.zzName+'======='+this.userList)
      let params = {
        userIds:this.userList,
        orgId:this.nodeId
      }
      addOrganizationUsersApi(params).then(res => {
        console.log(res)
        if(res.data.code == 200){
          this.userList = [];
          this.getListEngineers();
        }
      })
      this.loading = true;
      setTimeout(() => {
        this.visible = false;
        this.loading = false;
      }, 1000);
    },
    handleCancel(e) {
      this.visible = false;
    },
    // 打开数据授权弹窗（新增授权，不回显）
    showModalData() {
      this.editingAuth = false
      this.editingUserRoles = []
      this.authShowAllEng = false
      this.visibleData = true
      this.loadAuthCurrentOptions([])
    },
    // 打开数据授权弹窗并回显该用户已配置的权限
    showEditAuth(record) {
      this.userIds = [record.id]
      dataAuthorizationUserViewApi({ userId: record.id }).then(res => {
        console.log(res)
        if (res.data.code == 200) {
          const roles = res.data.data || []
          this.editingAuth = true
          this.editingUserRoles = roles
          // 已有授权全部在当前工程下则开关关闭，存在其他工程的则开启
          const hasOtherEng = roles.some(r => String(r.engineerId) !== String(this.engId))
          this.authShowAllEng = hasOtherEng
          const checkedIds = roles.map(r => r.orgId)
          this.visibleData = true
          if (hasOtherEng) {
            this.loadAuthAllEngTree(checkedIds)
          } else {
            this.loadAuthCurrentOptions(checkedIds)
          }
        }
      })
    },
    // 加载当前工程组织（开关关闭态），checkedOrgIds 用于编辑回显
    loadAuthCurrentOptions(checkedOrgIds) {
      let params = {
        engineerId:'-'+this.engId
      }
      dataAuthorizationViewApi(params).then(res => {
        console.log(res)
        if(res.data.code == 200){
          const arrOptions = (res.data.data || []).map(item => ({ label: item.name, value: item.id }))
          this.authOrgOptions = arrOptions
          this.authCheckedList = (checkedOrgIds || []).filter(id => arrOptions.some(o => o.value === id))
          this.authIndeterminate = !!this.authCheckedList.length && this.authCheckedList.length < arrOptions.length
          this.authCheckAll = arrOptions.length > 0 && this.authCheckedList.length === arrOptions.length
        }
      })
    },
    // 加载所有工程组织树（开关开启态），checkedOrgIds 用于编辑回显
    loadAuthAllEngTree(checkedOrgIds) {
      dataAuthorizationAllEngViewApi().then(res => {
        console.log(res)
        if(res.data.code == 200){
          const treeData = []
          const orgEngMap = {}
          ;(res.data.data || []).forEach(eng => {
            const children = (eng.children || []).map(o => {
              orgEngMap[o.id] = eng.id
              return { title: o.name, key: o.id }
            })
            treeData.push({ title: eng.name, key: 'eng-' + eng.id, children })
          })
          this.authTreeData = treeData
          this.orgEngMap = orgEngMap
          this.authSearchVal = ''
          this.authCheckedKeys = (checkedOrgIds || []).filter(id => orgEngMap[id] !== undefined)
          this.checkAllData = false
          this.indeterminateData = false
          // 默认展开全部工程层级
          this.authExpandedKeys = treeData.map(n => n.key)
        }
      })
    },
    // 切换“是否选择其他项目”开关，已有勾选自动转换
    onAuthModeChange(checked) {
      this.authShowAllEng = checked
      if (checked) {
        const checkedIds = this.authCheckedList.slice()
        this.authOrgOptions = []
        this.authCheckedList = []
        this.loadAuthAllEngTree(checkedIds)
      } else {
        const checkedIds = this.authCheckedKeys.filter(k => typeof k !== 'string' || k.indexOf('eng-') !== 0)
        this.authTreeData = []
        this.authCheckedKeys = []
        this.loadAuthCurrentOptions(checkedIds)
      }
    },
    // 关闭态复选框勾选
    onAuthCheckedListChange(checkedList) {
      this.authCheckedList = checkedList
      this.authIndeterminate = !!checkedList.length && checkedList.length < this.authOrgOptions.length
      this.authCheckAll = checkedList.length === this.authOrgOptions.length
    },
    // 关闭态全部勾选
    onAuthCheckAllChange(e) {
      this.authCheckedList = e.target.checked ? this.authOrgOptions.map(o => o.value) : []
      this.authIndeterminate = false
      this.authCheckAll = e.target.checked
    },
    // 树勾选
    onCheckAuthData(checkedKeys) {
      this.authCheckedKeys = checkedKeys
      const checkedEngCount = checkedKeys.filter(k => typeof k === 'string' && k.indexOf('eng-') === 0).length
      this.checkAllData = this.authTreeData.length > 0 && checkedEngCount === this.authTreeData.length
      this.indeterminateData = checkedEngCount > 0 && checkedEngCount < this.authTreeData.length
    },
    // 树展开/收缩
    onAuthExpand(expandedKeys) {
      this.authExpandedKeys = expandedKeys
    },
    // 树搜索
    onAuthSearch(val) {
      this.authSearchVal = val
      if (val) {
        // 搜索时展开全部节点，便于查看匹配项
        const keys = []
        const walk = (nodes) => {
          nodes.forEach(n => {
            if (n.children && n.children.length) {
              keys.push(n.key)
              walk(n.children)
            }
          })
        }
        walk(this.authTreeData)
        this.authExpandedKeys = keys
      }
    },
    // 全部勾选（树）
    onCheckAllAuthData(e) {
      this.checkAllData = e.target.checked
      this.indeterminateData = false
      if (e.target.checked) {
        // 勾选所有工程节点，级联选中全部组织
        this.authCheckedKeys = this.authTreeData.map(n => n.key)
      } else {
        this.authCheckedKeys = []
      }
    },
    handleOkData() {
      if (!this.userIds || this.userIds.length === 0){
        this.$message.warning('请先勾选用户')
        return
      }
      // 收集本次勾选的组织，按工程分组
      const groupByEng = {}
      if (this.authShowAllEng) {
        this.authCheckedKeys.forEach(key => {
          if (typeof key === 'string' && key.indexOf('eng-') === 0) return
          const engId = this.orgEngMap[key]
          if (engId !== undefined){
            if (!groupByEng[engId]) groupByEng[engId] = []
            groupByEng[engId].push(key)
          }
        })
      } else {
        if (this.authCheckedList.length > 0){
          groupByEng[this.engId] = this.authCheckedList.slice()
        }
      }
      const engIds = Object.keys(groupByEng)
      if (engIds.length === 0){
        this.$message.warning('请勾选组织机构')
        return
      }
      this.loadingData = true;
      const addRequests = () => {
        const requests = engIds.map(engId => {
          return addOrganizationRoleApi({
            userIds:this.userIds.join(','),
            orgIds:groupByEng[engId].join(','),
            engineerId:engId,
          })
        })
        Promise.all(requests).then(() => {
          this.getListEngineers()
          this.loadingData = false;
          this.visibleData = false;
        }).catch(() => {
          this.loadingData = false;
        })
      }
      // 编辑模式：先清除该用户原授权再新增，保证与勾选结果一致
      if (this.editingAuth) {
        const clearEngMap = {}
        this.editingUserRoles.forEach(r => {
          if (r.engineerId != null) clearEngMap[r.engineerId] = true
        })
        engIds.forEach(id => { clearEngMap[id] = true })
        const clearRequests = Object.keys(clearEngMap).map(engId => {
          return clearOrganizationRoleApi({
            userIds:this.userIds.join(','),
            engineerId:engId,
          })
        })
        if (clearRequests.length > 0) {
          Promise.all(clearRequests).then(addRequests).catch(() => {
            this.loadingData = false;
          })
        } else {
          addRequests()
        }
      } else {
        addRequests()
      }
    },
    clearOk() {
      let params = {
        userIds:this.userIds.join(','),
        engineerId:this.engId,
      }
      clearOrganizationRoleApi(params).then(res => {
        console.log(res)
        if(res.data.code == 200){
          this.getListEngineers()
        }
      })
    },
    handleCancelData(e) {
      this.visibleData = false;
    },
    // 获取列表
    getListEngineers() {
      
      let params = {
        loginName:this.searchVal.userName,
        name:this.searchVal.name,
        duty:this.searchVal.role,
        mobile:this.searchVal.tel,
        orgId:this.nodeId,
        orgPath:this.orgPath,
        current:this.pagination.current,
        size:this.pagination.pageSize,
      }
      getOrganizationList(params).then(res => {
        //
        console.log(res)
        this.data = res.data.data.records
        this.pagination.total = res.data.data.total
      })
    },
    // 分页
    handleTableChange(pagination, filters, sorter) {
      console.log(pagination)
      this.pagination = pagination
      this.getListEngineers()
    },
    delOrgUsers() {
      
      let params = {
        ids:this.delOrgIds.join(',')
      }
      delOrganizationUsersApi(params).then(res => {
        
        console.log(res)
        this.getListEngineers() 
      })
    },
    handleChange(value) {
      console.log(`selected ${value}`);
      this.userList = `${value}`
    },
  },
  watch: {
    engineerId(newVal,oldVal) {
      console.log(newVal)
      console.log(oldVal)
    },
    nodeId(newVal,oldVal) {
      this.getListEngineers()
    },
    // 去掉表单验证信息二次打开残留
    visible(val, newVal) {    //监听的是控制模态框显示或影藏开关的布尔值
          // 监视dialog状态（打开、关闭）
          if (val) {
              try {
                this.userOrgList = [];
              } catch (e) {}
          }
      }
  },
  // 引入store属性
  computed: {
    ...mapState(["count","labelCol","wrapperCol","engineerId"]),
    // 按搜索关键字过滤后的授权树（匹配组织保留，同时保留其父级工程链）
    filteredAuthTreeData() {
      const kw = (this.authSearchVal || '').trim()
      if (!kw) return this.authTreeData
      const filterNodes = (nodes) => {
        const res = []
        nodes.forEach(n => {
          if (n.children && n.children.length) {
            const children = filterNodes(n.children)
            if (children.length || n.title.indexOf(kw) > -1) {
              res.push(Object.assign({}, n, { children }))
            }
          } else if (n.title.indexOf(kw) > -1) {
            res.push(n)
          }
        })
        return res
      }
      return filterNodes(this.authTreeData)
    },
    rowSelection() {
      return {
        onChange: (selectedRowKeys, selectedRows) => {
          console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
          this.delOrgIds = []
          this.userIds = []
          selectedRows.forEach(element => {
            this.delOrgIds.push(element.orgUserId)
            this.userIds.push(element.id)
          });
          console.log(this.delOrgIds)
          console.log(this.userIds)
        },
        getCheckboxProps: record => ({
          props: {
            disabled: record.name === 'Disabled User', // Column configuration not to be checked
            name: record.name,
          },
        }),
      };
    },
  }
}



// WEBPACK FOOTER //
// ./src/views/Organization/Organization-mixins.js